/* eslint-disable eag/match-named-export -- Pre-existing grab-bag file with several exports */
import type {TeasState} from '../../types/TeasState';

export const selectGeneralSettings = (state: TeasState) => state.generalSettings;
